import React from "react";
import { useSelector } from "react-redux";

import { getUser } from "@gamedev-web/gamedev-sdk-core";

import { onMicrosoftEmailsNotAllowed } from "../../pages/GdkMiddlewareRequestPage/gdkMiddlewarePageContent";
import {
  isGdkEmailEnabledForOverride,
  isValidGdkEmail,
} from "../../pages/GdkMiddlewareRequestPage/helpers";
import * as styles from "./GdkMiddlewareDropdown.module.css";
import { GdkMiddlewareTextBox } from "./GdkMiddlewareTextBox";

export type EmailDropdownProps = {
  email?: string;
  setEmail?: (email: string) => void;
};

export const EmailBox = ({ email, setEmail }: EmailDropdownProps) => {
  const loggedInEmail = useSelector(getUser)?.emailAddress;
  return (
    <>
      <GdkMiddlewareTextBox
        value={email ?? ""}
        disabled={!isGdkEmailEnabledForOverride(loggedInEmail)}
        onChange={setEmail}
      />
      {!isValidGdkEmail(email) && (
        <span className={styles.emailError}>{onMicrosoftEmailsNotAllowed}</span>
      )}
    </>
  );
};
